// Planned or one-off: the two modalities a task can have.
//
// A PLANNED task hangs off a tier, which came out of an approved plan version.
// A ONE-OFF task has NO TIER and no plan: a fix, a diagnosis, an action out of
// an incident. It lives in a project and one of its repositories, is born a
// proposal and enters the queue when a person authorizes it — the same queue,
// the same review, the same rules. What it lacks is the tier, and every screen
// that assumed one has to say «puntual» instead of «Tier #null».
//
// `modality` comes on every row from Core (`planned` · `one_off`); rows older
// than the column read as planned.
//
// THE LISTING HIDES THEM UNLESS ASKED. `GET /admin/tasks` returns only planned
// tasks without `modality`, on purpose, so a client that could not show a task
// without a tier would not break when they appeared. This panel shows them, so
// it asks with `modality: all` — see ALL_MODALITIES in queries/paths.js.

export const MODALITY_LABEL = {
    planned: 'Planificada',
    one_off: 'Puntual',
};

export function isOneOff(task) {
    return task?.modality === 'one_off';
}
